/// <amd-module name="Repos/Views/CreatePullRequest/Components/CreatePullRequestCommitsTab" />
import * as React from "react";
import { ICommit, ICommitsTableProps } from "Repos/Common/Contracts/History";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { IPullRequestCreateInfo } from "../CreatePullRequestViewService";

export interface ICommitsTabContentProps {
    createInfo: IPullRequestCreateInfo;
}

export class CommitsTabContent extends VssComponent<ICommitsTabContentProps> {
    public render() {
        return (
            <div className="page-content page-content-top flex-column flex-grow">
                <Card className="bolt-table-card">
                    <WrappedComponent<ICommitsTableProps>
                        wrappedType="repos-commits-table"
                        dependencies={["ms.vss-code-web.commits-list"]}
                        wrappedProps={{
                            commits: this.props.createInfo.commits
                        }}
                    />
                </Card>
            </div>
        );
    }
}
